import { render, staticRenderFns } from "./PanelListItem.vue?vue&type=template&id=3ddf379c&scoped=true"
import script from "./PanelListItem.vue?vue&type=script&lang=js"
export * from "./PanelListItem.vue?vue&type=script&lang=js"
import style0 from "./PanelListItem.vue?vue&type=style&index=0&id=3ddf379c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf379c",
  null
  
)

export default component.exports